

















































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { SearchConfiguration } from '@empathybroker/tsclient-play/dist/models/search-configuration';

import { mapGetters } from 'vuex';

import { ConfigurationFeaturesStatus, CrudList, DataTable, NoDataFound } from '../../components';

import { AlignEnum, DomainEnum } from '../../enums';

import { ConfigurationsFormMixin, CrudListMixin } from '../../mixins';

import { DataTableColumn } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { APP_CONSTS } from '../../store/app/app.consts';

export default {
  name: 'search-configurations-list',
  components: {
    ConfigurationFeaturesStatus,
    CrudList,
    DataTable,
    NoDataFound
  },
  mixins: [CrudListMixin],
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      featuresTree: APP_CONSTS.getters.featuresTree
    }),
    tableColumns: function (): DataTableColumn[] {
      const fieldsMessages = this.messages.fields;
      return [
        {
          id: 'name',
          text: fieldsMessages.name.label,
          sortable: true,
          width: '75%'
        }, {
          id: 'keywords',
          text: fieldsMessages.keywords.label
        },
        ...this.pivotsColumns,
        {
          id: 'modified',
          text: fieldsMessages.features.label,
          width: '13rem',
          align: AlignEnum.CENTER
        }, {
          id: 'meta.updateDate',
          text: fieldsMessages.updateDate.label,
          sortable: true
        }, {
          id: 'meta.user',
          text: fieldsMessages.user.label,
          sortable: true
        }, {
          id: 'enabled',
          text: fieldsMessages.enabled.label,
          sortable: true
        }
      ];
    },
    toolsAvailability: function () {
      return ConfigurationsFormMixin.computed.toolsAvailability.bind(this)();
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.CONFIGURATION,
      routes: {
        create: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].create,
        update: ROUTER_CONSTS.routes.configurations[DomainEnum.SEARCH].update
      },
      messages: this.$epb.messages.tools.configurations
    };
  },
  props: {
    loading: Object
  },
  methods: {
    getKeywordsText: function (configuration: SearchConfiguration): string {
      return configuration.context.keywords.map((keyword: string) => `"${ keyword }"`).join(', ');
    }
  }
};
